import {forwardRef, memo, useEffect, useImperativeHandle, useMemo, useRef, useState} from 'react';
import sdk from '@/sdk';
import routers, {buildPath} from '@/config/routers';
import {useHistory, useRouteMatch} from 'react-router-dom';
import MessageContainer from '../MessageContainer';

interface IKuToPersonalPageGuide {
    children: any;
}
const KuToPersonalPageGuide: React.FC<IKuToPersonalPageGuide> = memo(forwardRef(({children}, ref: any) => {
    const guideIsRead = sdk.as.user?.settings?.newGuide?.knowledgeCoinKuToPersonalPageIsRead;
    const [isShow, changeIsShow] = useState(false);
    const isPersonalHome = !!useRouteMatch({path: routers.PersonalHome.path}); // 是否个人主页
    const history = useHistory();

    async function checkShouldShowNewGuide() {
        if (guideIsRead) {
            return;
        }
        changeIsShow(true);
    }

    useEffect(() => {
        checkShouldShowNewGuide();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const closeEffect = async () => {
        await sdk.as.updateNewGuide({
            knowledgeCoinKuToPersonalPageIsRead: true,
        });
        changeIsShow(false);
    };

    const clickButtonToClose = async () => {
        if (guideIsRead) {
            return false;
        }
        // 需要进行更新
        await closeEffect();

        // 如果当前已经在PersonalHome了，不进行跳转
        if (isPersonalHome) {
            return;
        }

        // 如果不在personalPage，需要进行页面跳转
        const path = buildPath(routers.PersonalHome.path, {
            userName: sdk.as.user?.avatar || '',
        });
        history.push(path);
    };

    const cancel = async () => {
        await closeEffect();
    };

    // 将Guide的action方法暴露给组件实例
    useImperativeHandle(ref, () => ({
        onAction: () => {
            clickButtonToClose();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [isShow]);

    return isShow ? <div style={{position: 'relative'}}>
        <MessageContainer
            title="个人主页升级啦！"
            content="可查看个人成就数据，了解最新动态消息，快去看看吧～"
            buttonContent="去查看"
            onChangeVisible={changeIsShow}
            onClickButtonToClose={clickButtonToClose}
            name="kuToPersonalPageGuide"
            onClickCancel={cancel}
        >
            {children}
        </MessageContainer>
    </div> : <>
        {children}
    </>;
}));

export default KuToPersonalPageGuide;
